import { BaseProyectaService } from "./base-proyecta.service";
import { ILang } from "../../models";
import { IGetUserInfoRequest } from "../base/graph.service";
import { Enums, Dictionary, String, Constants } from "../../utils/utilities";
import { UserDTO, ISPItem } from "../../models";
import { IConfig, SPEnvironment } from "@/config/config";
const config = require('@/config/config.json') as IConfig;

export interface ISessionService{
    getLangs(): Promise<ILang[]>;
    getParams(): Promise<any[]>;
    getCurrentUserInfo(): Promise<any>;
    getLabels(langId: number): Promise<Dictionary<string,string>>;
    getRoutes(langId: number): Promise<any[]>;
}


export class SessionService extends BaseProyectaService implements ISessionService {
    public async getLangs(): Promise<ILang[]> {
        const langs = await this.spListService.getItems<ISPItem>({listName:Enums.ListTypes.Langs, filter:Constants.FiltersFormats.LANG_IS_ACTIVE})
        return langs.map(item => {
            return {
                id: item.Id,
                label: item.Title
            }
        });
    }
    public async getParams(): Promise<ILang[]> {
        const params = await this.spListService.getItems<any>({listName:Enums.ListTypes.Params})
        let data = Object.assign({}, ...params.map((x) => ({ [x.Title]: x.OCTAVIAValor })));
        return data;
    }
    async getCurrentUserInfo(): Promise<any>{
        const userRequestInfo: IGetUserInfoRequest = {
            properties: Object.keys(new UserDTO()).join(',')
        };
        if(config.environment === SPEnvironment.local){
           userRequestInfo.email = config.mockUser; 
        } else {
            userRequestInfo.email = await this.graphService.getAzureADCurrentUserEmail();
        }
        const userInfo = await this.graphService.getCurrentUserInfo(userRequestInfo);
        return userInfo; 
    }

    public async getLabels(langId: number): Promise<Dictionary<string,string>>{
        const labels = await this.spListService.getItems<any>({
            listName:Enums.ListTypes.Labels,
            filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_BY_ID, langId),
            caching: true
        });
        var dics = new Dictionary<string,string>();
        for(var i = 0; i < labels.length; i++){
            const label = labels[i];
            dics.add(label["Title"], label["OCTAVIAValorTraduccion"]);
        }   
        return dics;        
    }

    public async getRoutes(langId: number): Promise<any[]>{
        const routes = await this.spListService.getItems<any>({
            listName:Enums.ListTypes.Routes,
            filter: String.Format(Constants.FiltersFormats.LANGUAGE_FILTER_BY_ID, langId),
            caching: true
        });
        return routes;
    }
}
